/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
let moment = require('moment');

import './bootstrap.js';
import bugsnag from '@bugsnag/js';
import bugsnagVue from '@bugsnag/plugin-vue';
import Vue from 'vue';

window.Vue = Vue;
window.moment = moment;

var bugsnagClient = bugsnag({
    apiKey: process.env.MIX_BUGSNAG_API_KEY,
    releaseStage: process.env.MIX_APP_ENV,
    notifyReleaseStages: ['production'],
});

bugsnagClient.use(bugsnagVue, Vue);
